import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

import { PropType, ref } from "vue";  
  import { LoanApplication } from "src/types/loan-application/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DealerOptionsForm',
  props: {
    proposal: {
      type: Object as PropType<LoanApplication>,
      default: null
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {

  const props = __props

  const contactOptions = ref( [
    {
      label: 'Car Finance 247',
      value: 0
    },
    {
      label: 'Dealer',
      value: 1
    }
  ])

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-subtitle1 q-pb-md" }, " Who would you like to contact the customer to discuss the approval? ", -1)),
    _createVNode(_component_q_radio, {
      modelValue: __props.proposal.firstContactSource,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.proposal.firstContactSource) = $event)),
      val: 0,
      label: "Car Finance 247",
      class: "text-body2"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_q_radio, {
      modelValue: __props.proposal.firstContactSource,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.proposal.firstContactSource) = $event)),
      val: 1,
      label: "Dealer",
      class: "text-body2"
    }, null, 8, ["modelValue"])
  ]))
}
}

})